export function normalizeWeatherHourKey(hour: string): string {
  const trimmed = hour.trim();
  if (!trimmed) {
    return "00:00";
  }

  const dateTimeMatch = trimmed.match(/(?:T|\s)(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (dateTimeMatch) {
    return `${dateTimeMatch[1].padStart(2, "0")}:${dateTimeMatch[2]}`;
  }

  const [hourPart, minutePart = "00"] = trimmed.split(":");
  const normalizedHour = hourPart.padStart(2, "0");
  const normalizedMinute = minutePart.padStart(2, "0").slice(0, 2);
  return `${normalizedHour}:${normalizedMinute}`;
}
